import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
declare let L: any;
import { ParameterService } from '../../services/parameter/parameter.service';
import { DashboardMapFilters, DashboardMapOptions, MapLocation } from './utils/dashboard-map-types';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/api/api.service';
import { AuthService } from '../../services/auth/auth.service';
import { MapLocationInfoComponent } from './map-location-info/map-location-info.component';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { MapSearchNavigationComponent } from './map-search-navigation/map-search-navigation.component';
import { WatchTeamMembersCardComponent } from '../watch-team-members-card/watch-team-members-card.component';
import { MapIconServiceService } from './services/map-icon-service.service';
import {Marker} from "leaflet";

@Component({
  selector: 'app-dashboard-map',
  templateUrl: './dashboard-map.component.html',
  styleUrl: './dashboard-map.component.scss'
})
export class DashboardMapComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('infoPanel') infoPanel: MapLocationInfoComponent;
  @ViewChild('searchNavigation') searchNavigation: MapSearchNavigationComponent;
  @ViewChild('teamMembers') teamMembers: WatchTeamMembersCardComponent;

  isVisible: boolean = false;
  isFiltersVisible: boolean = false;
  isSearchVissible: boolean = false;
  searchControl = new FormControl('');
  isSearching: boolean = false;
  matchedList: L.Marker[] = [];
  refreshing: boolean = true;

  private map!: L.Map;
  startLocation: { latitude: number; longitude: number } = {
    latitude: 41.0152, longitude: 28.9768,
  };
  intervalLiveLocation: any;
  lastUpdate: Date;
  icons: {
    vehicle: {
      regular: L.Icon,
      highlight: L.Icon
    },
    case: {
      regular: L.Icon,
      highlight: L.Icon
    },
    //  appointment = res --> tabloda 'appointment' olarak tutulduğu için
    appointment: {
      regular: L.Icon,
      highlight: L.Icon
    },
    org: {
      regular: L.Icon,
      highlight: L.Icon
    }
  };
  locations: MapLocation[] = [];
  selectedLocation: MapLocation | undefined;

  options: DashboardMapOptions = {
    vehicleTypeOptions: [],
    caseTypeOptions: [],
    caseStatusOptions: [],
    betweenTimeOptions: [],
    engineOptions: [],

    pageRefreshOptions: this.generateRefreshOptions(),

    filters: {
      vehicle: {
        vehicleTypes: [],
        engine: undefined,
        showVehicleDetails: true,
      },
      case: {
        isActive: false,
        caseTypes: [],
        statuses: ['started'],
        withTeam: true,
        withoutTeam: true,
      },
      res: {
        isActive: false,
        caseTypes: [],
        time: 60
      },
      org: {
        isActive: false,
        time: 60
      },
      selectedRefreshRate: 15,
    }
  }
  activeFilters: DashboardMapFilters;

  constructor(
    private readonly authService: AuthService,
    private readonly apiService: ApiService,
    private readonly parameterService: ParameterService,
    private readonly translate: TranslateService,
    private readonly iconService: MapIconServiceService
  ) {
    this.translate.setDefaultLang('tr');
    this.translate.use('tr');
  }

  ngOnInit() {
    this.loadFiltersData();
    this.loadSearch()

  }
  loadSearch() {
    this.searchControl.valueChanges
      .pipe(
        tap(() => this.isSearching = true),
        debounceTime(300),
        distinctUntilChanged((prev, curr) => {
          // değer aynı ise aramayı kapatıyoruz
          const isSameValue = prev === curr;
          if (isSameValue) {
            this.isSearching = false;
          }
          return isSameValue;
        })
      )
      .subscribe((searchText: string | null) => {
        this.isSearching = false;
        if (!searchText) {
          // Arama silindiğinde haritanın ilk konumuna dönmesi
          if (this.map) {
            this.map.flyTo([this.startLocation.latitude, this.startLocation.longitude], 10.5);
          }
          this.searchNavigation.deactivate();
          return;
        }
        this.searchData(searchText);
      });
  }
  private liveLocationGet() {
    this.refreshing = true;
    if(!this.isVisible) {
      return;
    }
    this.apiService.post<MapLocation[]>(`dashboard-map/locations`, this.activeFilters)
    .subscribe(res => {
      this.lastUpdate = new Date();
      this.locations = res;
      this.updateMapPins();
      this.infoPanel.refresh();

      this.refreshing = false;
    });
  }

  ngAfterViewInit(): void {
    this.close();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalLiveLocation);
  }

  open() {
    this.isVisible = true;
    setTimeout(() => {
      this.initMap();
      this.resetState();
      this.saveFilters();
    }, 300);
  }

  private resetState() {
    this.isFiltersVisible = false;
    this.isSearchVissible = false;
    this.isSearching = false;
    this.searchControl.setValue('');
    this.matchedList = [];
  }

  close() {
    this.isVisible = false;
    if (this.map) {
      this.map.remove();
    }
    if(this.intervalLiveLocation) {
      clearInterval(this.intervalLiveLocation);
    }
    this.selectedLocation = undefined;
  }

  filtersClicked() {
    this.isFiltersVisible = !this.isFiltersVisible;
  }

  searchClicked() {
    this.isSearchVissible = !this.isSearchVissible;
  }

  saveFilters() {
    clearInterval(this.intervalLiveLocation);
    this.filtersToActiveFilters();

    localStorage.setItem('dashboard-map-filters', JSON.stringify({
      user: this.authService.getUserId(),
      filters: this.activeFilters
    }));

    this.liveLocationGet();
    this.intervalLiveLocation = setInterval(() => {
      this.liveLocationGet();
    }, this.options.filters.selectedRefreshRate * 1000);
  }

  private initMap() {

    this.map = L.map('map', {
      preferCanvas: true,
      attributionControl: true,
      fadeAnimation: false,
    }).setView(
      [this.startLocation.latitude, this.startLocation.longitude], 10.5
    );
    this.map.attributionControl.remove();
    this.setMapLayers();

  }

  private setMapLayers() {
    let layers = {
        White: L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        //crossOrigin: true,
        maxZoom: 30
      }),
      OSM: L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 30,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }),

      Streets: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      ),
      Hybrid: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      ),
      Satellite: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      ),
      Terrain: L.tileLayer(
        'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
        {
          maxZoom: 30,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      )
    };
    layers.White.addTo(this.map);
    L.control.layers(layers, undefined, {position: 'bottomright'}).addTo(this.map);
  }

  /*  Eski sabit ikon sistemi
  private loadMapIcons() {
    this.icons = {
      vehicle: {
        regular: L.icon({
          iconUrl: 'assets/markers/dashboard-map/vehicle.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -28]
        }),
        highlight: L.icon({
          iconUrl: 'assets/markers/dashboard-map/vehicle.svg',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -28]
        })
      },
      case: {
        regular: L.icon({
          iconUrl: 'assets/markers/dashboard-map/case.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -28]
        }),
        highlight: L.icon({
          iconUrl: 'assets/markers/dashboard-map/case.svg',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -28]
        })
      },
      appointment: {
        regular: L.icon({
          iconUrl: 'assets/markers/dashboard-map/res.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -28]
        }),
        highlight: L.icon({
          iconUrl: 'assets/markers/dashboard-map/res.svg',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -28]
        })
      },
      org: {
        regular: L.icon({
          iconUrl: 'assets/markers/dashboard-map/org.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -28]
        }),
        highlight: L.icon({
          iconUrl: 'assets/markers/dashboard-map/org.svg',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -28]
        })
      }
    }
  }*/

  private loadFiltersData() {

    //  Araç Tipleri
    this.parameterService.getParameterValues('data-group', 'vehicle-types').subscribe(res => {
      this.options.vehicleTypeOptions = res?.datas?.values.map((data: any) => {
        return {label: data.valueObject.name.value, value: data.id};
      });
    });

    //  Vaka Tipleri
    this.parameterService.getParameterValues('data-group', 'caseTypes').subscribe(res => {
      this.options.caseTypeOptions = res?.datas?.values.map((data: any) => {
        return {label: data.valueObject.name.value, value: data.id};
      });
    });

    //  Zaman Aralığı
    this.parameterService.getParameterValues('location-parameters', 'beforeTime').subscribe(res => {
      this.options.betweenTimeOptions = res.datas?.values.map((data: any) => ({
        label: data.valueObject.name.value, value: data.valueObject.beforeTime.value,
      }));
    });

    //  Araç Motor Durumu
    this.options.engineOptions = [
      {label: 'Tüm Motor Durumları', value: undefined},
      {label: 'Açık', value: 'A'},
      {label: 'Kapalı', value: 'I'}
    ];

    //  Vaka Durumu
    this.options.caseStatusOptions = [
      {label: 'Devam Ediyor', value: 'started'},
      {label: 'Tamamlandı', value: 'finished'}
    ];

    //  Kullanıcının kayıtlı filtreleri var ise yükle
    const storageItem = localStorage.getItem('dashboard-map-filters');
    if(storageItem) {
      this.options.filters = JSON.parse(storageItem)?.filters ?? this.options.filters;
    }

    this.filtersToActiveFilters();

  }

  private generateRefreshOptions(): { label: string, value: number }[] {
    const secondText = 'Saniye'
    const minuteText = 'Dakika'
    return [5, 10, 15, 30, 60, 120, 300, 600, 1800].map( time => {
      const isSecond = (time / 60) < 1;
      const labelText = isSecond ? `${time} ${secondText}`
      : `${time/60} ${minuteText}`;
      return {
        label: labelText,
        value: time
      }
    });
  }

  private updateMapPins() {

    this.map.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        this.map.removeLayer(layer);
      }
    });
    for (const location of this.locations) {
      const highlightCond = (this.selectedLocation && this.selectedLocation.id === location.id && this.selectedLocation.type === location.type);
      const position: any = [Number(location.latitude), Number(location.longitude)];

      const marker = L.marker(position, { icon: this.iconService.getIcon(location, highlightCond, this.activeFilters.vehicle.showVehicleDetails) });

      marker.addTo(this.map);

      marker.on('click', () => {
        this.markerClicked(marker);
      });

      (marker as any)._locationData = location;

      //  Pinler güncellenince otomatik takip etmesi
      if (this.selectedLocation && location.type === this.selectedLocation?.type && location.id === this.selectedLocation.id) {
        this.selectedLocation = location;
        this.map.flyTo([this.selectedLocation.latitude, this.selectedLocation.longitude]);
      }
    }
  }

  updateLocationRelation(trackedLocations: {type: string, id: number}[]) {

    this.removeTrackedLines();

    if(!this.selectedLocation) { return; }

    this.map.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        const location: MapLocation = (layer as any)._locationData;
        const matched = trackedLocations.find(loc => loc.id === location.id && loc.type === location.type);

        if (matched) {
          const firstPoint = [this.selectedLocation?.latitude, this.selectedLocation?.longitude];
          const secondPoint = [location.latitude, location.longitude];
          L.polyline([firstPoint, secondPoint] as any, {
            opacity: 0.6,
            smoothFactor: 1,
            dashArray: '10, 15',
            lineCap: 'round'
          }).addTo(this.map);
        }

      }
    });

  }

  private removeTrackedLines() {
    this.map.eachLayer((layer) => {
      if (layer instanceof L.Polyline) {
        this.map.removeLayer(layer);
      }
    });
  }

  private markerClicked(marker: L.Marker) {
    const location: MapLocation = (marker as any)._locationData;

    if(this.selectedLocation && this.selectedLocation.id === location.id && this.selectedLocation.type === location.type) {
      this.selectedLocation = undefined;
      this.infoPanel.close();
      this.unHighlightAllMarkers();
    } else {
      this.selectedLocation = {...location};
      this.infoPanel.open(location);
      this.highlightMarker(marker);
    }

  }

  private highlightMarker(marker: L.Marker) {
    this.unHighlightAllMarkers();
    const location: MapLocation = (marker as any)._locationData;
    marker.setIcon(this.iconService.getIcon(location, true, this.activeFilters.vehicle.showVehicleDetails));
    this.map.flyTo([location.latitude, location.longitude]);
  }

  private unHighlightAllMarkers() {
    this.map.eachLayer((layer: any) => {
      if (layer._icon) {
        const location: MapLocation = layer._locationData;
        layer.setIcon(
          this.iconService.getIcon(
            location,
            false,
            this.activeFilters.vehicle.showVehicleDetails
          )
        );
      }
    });

  }

  private filtersToActiveFilters() {
    this.activeFilters = {
      vehicle: {
        vehicleTypes: [...this.options.filters.vehicle.vehicleTypes],
        engine: this.options.filters.vehicle.engine,
        showVehicleDetails: this.options.filters.vehicle.showVehicleDetails,
      },
      case: {
        isActive: this.options.filters.case.isActive,
        caseTypes: [...this.options.filters.case.caseTypes],
        statuses: [...this.options.filters.case.statuses],
        withTeam: this.options.filters.case.withTeam,
        withoutTeam: this.options.filters.case.withoutTeam
      },
      res: {
        isActive: this.options.filters.res.isActive,
        caseTypes: [...this.options.filters.res.caseTypes],
        time: this.options.filters.res.time
      },
      org: {
        isActive: this.options.filters.org.isActive,
        time: this.options.filters.org.time
      },
      selectedRefreshRate: this.options.filters.selectedRefreshRate
    };
  }

  private searchData(searchText: string) {

    this.matchedList = [];
    const searchLower = searchText.toLowerCase();

    this.map.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        const location: MapLocation = (layer as any)._locationData;

        if(!location) { return; }

        const protocolNo = location.protocolNo?.toLowerCase() ?? '';
        const licensePlate = location.licensePlate?.toLowerCase() ?? '';
        const vehicleNo = location.vehicleNo?.toLowerCase() ?? '';

        if(protocolNo.includes(searchLower) || licensePlate.includes(searchLower) || vehicleNo.includes(searchLower)) {
          if (layer instanceof Marker) {
            this.matchedList.push(layer);
          }
        }
      }
    });

    if(this.searchNavigation && this.matchedList.length > 0) {
      this.searchNavigation.activate(this.matchedList, searchLower);
    } else if(this.matchedList.length === 0) {
      this.searchNavigation.deactivate();
      if(this.map) {
        this.map.flyTo([this.startLocation.latitude, this.startLocation.longitude], 10.5);
      }
    }
  }

  onMarkerChanged(marker: L.Marker) {
    const location: MapLocation = (marker as any)._locationData;

    this.map.eachLayer((layer) => {

      if (layer instanceof L.Marker) {
        const layerLocation: MapLocation = (layer as any)._locationData;

        if(layerLocation.id === location.id && layerLocation.type === location.type) {
          this.map.flyTo(marker.getLatLng(), 18, {
            duration: 3,
            easeLinearity: 0.1
          });
          this.markerClicked(marker);
        }

      }

    });

  }

  personelInfoClicked(vehicle: any) {
    const now = new Date();
    this.teamMembers.initilize(vehicle.dot.dotName, {
      dotId: vehicle.dot.id,
      vehicleId: vehicle.id,
      startDate: now,
      endDate: now,
    });
  }

  onInfoPanelClosed() {
    this.unHighlightAllMarkers();
    this.removeTrackedLines();
    this.selectedLocation = undefined;
  }

  checkChanged(change: 'withTeam' | 'withoutTeam') {
    switch (change) {
      case 'withTeam':
        if(!this.options.filters.case.withTeam && !this.options.filters.case.withoutTeam) {
          this.options.filters.case.withoutTeam = true;
        }
        break;
      case 'withoutTeam':
        if(!this.options.filters.case.withTeam && !this.options.filters.case.withoutTeam) {
          this.options.filters.case.withTeam = true;
        }
        break;
      default:
        break;
    }
  }

}
